import { useEffect, useRef, useState } from "react";
import type { InfoCardProps } from "./interface";
import {
  CardContainer,
  CardTitle,
  GridContainer,
  GridLabel,
  GridRow,
  GridValue,
  ImageContainer,
} from "./style";

function TruncatedValue({ value }: { value: React.ReactNode }) {
  const ref = useRef<HTMLSpanElement>(null);
  const [overflows, setOverflows] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () => setOverflows(el.scrollWidth > el.clientWidth);
    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [value]);

  return (
    <GridValue
      ref={ref}
      title={overflows && typeof value === "string" ? value : undefined}
      $overflows={overflows}
    >
      {value}
    </GridValue>
  );
}

export function InfoCard({
  title,
  labels = [],
  values = [],
  imgSrc,
}: InfoCardProps) {
  return (
    <CardContainer>
      <CardTitle title={title}>{title}</CardTitle>
      {imgSrc && <ImageContainer src={imgSrc} alt={`${title}-picture`} />}
      <GridContainer>
        {labels.map((label, i) => (
          <GridRow key={i} $index={i}>
            <GridLabel>{label}</GridLabel>
            <TruncatedValue value={values[i]} />
          </GridRow>
        ))}
      </GridContainer>
    </CardContainer>
  );
}
